import React from "react";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import "../styles/sideBar.css"

export default function AdminPanel() {

    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await signOut(auth);        
            navigate('/');
        } catch (error) {
            console.error('Błąd podczas wylogowania:', error);
        }
    }


    return (
        <div className="side-margin" style={({display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "column", backgroundColor: "rgb(250,250,250)", minHeight: "100vh", overflowY: "scroll", gap: "15px"})}>
            <div style={({display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column", gap: "15px", width: "90%", marginTop: "20px"})}>

            </div>
        </div>
    )
}